var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header"),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-2 pt-9",
              attrs: { cols: "12", align: "left" },
            },
            [
              _c("v-col", { staticClass: "ma-0 pa-0", attrs: { cols: "12" } }, [
                _vm._v(" " + _vm._s("X-API-KEY") + " "),
              ]),
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0 mt-1", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "6" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.xApiKey,
                            expression: "xApiKey",
                          },
                        ],
                        attrs: {
                          id: "input_grey",
                          placeholder: "x-api-key를 입력하세요",
                        },
                        domProps: { value: _vm.xApiKey },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.xApiKey = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0 pl-2", attrs: { cols: "1" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            width: "100%",
                            height: "2.5rem",
                            id: "blue_btn",
                          },
                          on: { click: _vm.keyInputFunc },
                        },
                        [_vm._v(" " + _vm._s("저장") + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mt-7", attrs: { cols: "12" } },
                [_vm._v(" " + _vm._s("Role Group Name") + " ")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mt-1",
                  staticStyle: { width: "100%" },
                  attrs: { cols: "8" },
                },
                [
                  _c("v-select", {
                    attrs: {
                      "background-color": "#272727",
                      dark: "",
                      items: _vm.roleGroupNameList,
                      dense: "",
                      "hide-details": "",
                      outlined: "",
                      "item-text": "name",
                      "item-value": "key",
                    },
                    model: {
                      value: _vm.selectedRoleGroupKey,
                      callback: function ($$v) {
                        _vm.selectedRoleGroupKey = $$v
                      },
                      expression: "selectedRoleGroupKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0 mt-7", attrs: { cols: "8" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { align: "center", justify: "space-between" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { align: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "auto" },
                                },
                                [_vm._v(" " + _vm._s("Role Detail") + " ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 ml-2",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { right: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    { attrs: { dark: "" } },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    " mdi-information-outline "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(" ✕ : not avaiable "),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _c("span", [_vm._v(" ○ : avaiable ")]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _c("span", [
                                        _vm._v(
                                          " C1 : changable (default true) "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _c("span", [
                                        _vm._v(
                                          " C2 : changable (default false) "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.roleList.created == null
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    width: "5rem",
                                    height: "2rem",
                                    id: "blue_btn",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveRole()
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s("저장") + " ")]
                              ),
                            ],
                            1
                          )
                        : _vm.roleModify != true
                        ? _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    width: "5rem",
                                    height: "2rem",
                                    id: "blue_btn",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeToModify()
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s("수정") + " ")]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    width: "5rem",
                                    height: "2rem",
                                    id: "grey_btn",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.cancelBtn()
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s("취소") + " ")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    width: "5rem",
                                    height: "2rem",
                                    id: "blue_btn",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.modifyRole()
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s("저장") + " ")]
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-col", { staticClass: "ma-0 pa-0", attrs: { cols: "8" } }, [
                _c(
                  "table",
                  { attrs: { id: "role_table" } },
                  [
                    _c("thead", [
                      _c("th", [
                        _vm._v(
                          _vm._s("Role List (PRIVATE_STORE_PARENTAL_ADMIN)")
                        ),
                      ]),
                      _c("th", [_vm._v(_vm._s("Availability"))]),
                    ]),
                    _vm.areaLoading == true
                      ? [
                          _c("v-skeleton-loader", {
                            attrs: {
                              boilerplate: false,
                              elevation: "0",
                              dark: "",
                              type: "list-item-three-line, list-item-two-line, list-item-three-line",
                            },
                          }),
                        ]
                      : _vm.selectedRoleGroupKey == null
                      ? [
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s("데이터가 없습니다"))]),
                            ]),
                          ]),
                        ]
                      : _vm.roleList.created != null && _vm.roleModify != true
                      ? [
                          _c(
                            "tbody",
                            _vm._l(_vm.roleMap, function (item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [_vm._v(_vm._s(item[0]))]),
                                item[1] == 0
                                  ? _c(
                                      "td",
                                      { staticClass: "td_availability" },
                                      [_vm._v(" " + _vm._s("✕") + " ")]
                                    )
                                  : item[1] == 1
                                  ? _c(
                                      "td",
                                      { staticClass: "td_availability" },
                                      [_vm._v(" " + _vm._s("○") + " ")]
                                    )
                                  : item[1] == 2
                                  ? _c(
                                      "td",
                                      { staticClass: "td_availability" },
                                      [_vm._v(" " + _vm._s("C1") + " ")]
                                    )
                                  : _c(
                                      "td",
                                      { staticClass: "td_availability" },
                                      [_vm._v(" " + _vm._s("C2") + " ")]
                                    ),
                              ])
                            }),
                            0
                          ),
                        ]
                      : _vm.roleModify == true
                      ? [
                          _c(
                            "tbody",
                            _vm._l(_vm.roleMap, function (item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [_vm._v(_vm._s(item[0]))]),
                                _c(
                                  "td",
                                  { staticClass: "td_availability" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        "background-color": "#272727",
                                        dark: "",
                                        items: _vm.availability,
                                        dense: "",
                                        "hide-details": "",
                                        outlined: "",
                                        "item-text": "label",
                                        "item-value": "value",
                                      },
                                      model: {
                                        value: item[1],
                                        callback: function ($$v) {
                                          _vm.$set(item, 1, $$v)
                                        },
                                        expression: "item[1]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      : [
                          _c(
                            "tbody",
                            _vm._l(_vm.roleMap, function (item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [_vm._v(_vm._s(item[0]))]),
                                _c(
                                  "td",
                                  { staticClass: "td_availability" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        "background-color": "#272727",
                                        dark: "",
                                        items: _vm.availability,
                                        dense: "",
                                        "hide-details": "",
                                        outlined: "",
                                        "item-text": "label",
                                        "item-value": "value",
                                      },
                                      model: {
                                        value: item[1],
                                        callback: function ($$v) {
                                          _vm.$set(item, 1, $$v)
                                        },
                                        expression: "item[1]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ],
                  ],
                  2
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("AddRoleDialog", {
        attrs: {
          dialogVisible: _vm.addRoleDialogVisible,
          roleGroupName: _vm.selectedRoleGroupName,
          roleGroupKey: _vm.selectedRoleGroupKey,
        },
        on: { visible: _vm.addRoleDialogVisibleFunc },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }